import { createConfig, webSocket } from "@wagmi/core";
import { chiliz } from "viem/chains";

export const networks = [chiliz];
export const wagmiConfig = createConfig({
  chains: [chiliz],
  transports: {
    [chiliz.id]: webSocket("wss://chiliz-rpc.publicnode.com"),
  },
});
